import replace from "lodash/replace";
import locale from "./format.locale";
export const formatNumberToShorter = (value, greedy) => {
    const val = Math.abs(value);
    const abbr = [locale.THOUSAND, locale.MILLION, locale.BILLION, locale.TRILLION];
    let result = value.toString();
    for (let i = abbr.length - 1; i >= 0; i -= 1) {
        const size = 10 ** ((i + 1) * 3);
        if (val >= size || (greedy && value >= size / 10)) {
            result = `${replace((Math.round((value * 100) / size) / 100).toString(), ".", ",")} ${abbr[i]}`;
            break;
        }
    }
    return result;
};
export const formatNumber = (value) => {
    if (!value || Number.isNaN(value))
        return "";
    return replace(value.toString(), /\B(?=(\d{3})+(?!\d))/g, " ");
};
export const formatFractionToPercent = (fraction, fractionDigits = 2) => {
    if (fraction === undefined)
        return "";
    const percent = +(fraction * 100);
    const calculationSensitivity = 1 / 10 ** fractionDigits;
    if (percent < calculationSensitivity)
        return `<${calculationSensitivity}%`;
    return percent % 1 !== 0 ? `${percent.toFixed(fractionDigits)}%` : `${percent}%`;
};
